<template>
  <guest-order-details-dialog
    v-model="open"
    :order="order"
    :changing-status-order-id="changingStatusOrderId"
    @change-status="changeStatus"
  />
</template>

<script>
import GuestOrderDetailsDialog from "@/components/dialogs/GuestOrderDetailsDialog.vue";
import hasSnackbar from "@/mixins/hasSnackbar";
import orderService from "@/services/order";
import reportService from "@/services/report";

// "Detalj narudžbe" iz finansija - isti dijalog kao u izvještajima; narudžba se
// učitava po ID-u (orders/guest-orders/{id}/show) tek kad se dijalog otvori.
export default {
  name: "FinanceOrderDetailDialog",

  components: { GuestOrderDetailsDialog },

  mixins: [hasSnackbar],

  props: {
    value: { type: Boolean, default: false },
    orderId: { type: [Number, String], default: null },
  },

  data: () => ({
    order: null,
    changingStatusOrderId: null,
  }),

  computed: {
    open: {
      get() {
        return this.value && !!this.order;
      },
      set(val) {
        this.$emit("input", val);
        if (!val) this.order = null;
      },
    },
  },

  watch: {
    value(isOpen) {
      if (isOpen) this.load();
    },
  },

  methods: {
    async load() {
      if (!this.orderId) return;
      this.order = null;
      try {
        const { data } = await orderService.getGuestOrderDetails(this.orderId);
        this.order = data?.data || data;
      } catch (error) {
        this.$emit("input", false);
        this.showErrorSnackbar(this.$t("finance_order_load_error"));
      }
    },

    async changeStatus({ order, newStatus }) {
      if (!order || order.state === newStatus) return;
      this.changingStatusOrderId = order.id;
      try {
        await reportService.changeCourierOrderStatus(order.id, newStatus);
        order.state = newStatus;
        if (order.order_guest_status) order.order_guest_status.status = newStatus;
        this.showSuccessSnackbar(this.$t("status_changed_successfully"));
      } catch (error) {
        this.showErrorSnackbar(this.$t("status_change_error"));
      } finally {
        this.changingStatusOrderId = null;
      }
    },
  },
};
</script>
